import { fromEvent, noop, Observable } from 'rxjs';
import { createConnectingService } from '../base/connectingService';
import { ElementService } from '../dom/elementService';
import { createMemoryTextService, TextService } from './textService';

type InputElement = HTMLTextAreaElement | HTMLInputElement;

export function createInputTextService(element$: Observable<InputElement | null>): TextService {
  return createConnectingService(
    element$,
    createMemoryTextService,
    element => new InputTextService(element),
    (nextService, prevService) => {
      nextService.setText(prevService.text);
    },
  );
}

export class InputTextService extends ElementService<InputElement> implements TextService {
  constructor(element: InputElement) {
    super(element, {
      changes$: fromEvent(element, 'input'),
    });
  }

  get text() {
    return this.element.value;
  }

  setText(text: string) {
    this.element.value = text;
  }

  decorateText = noop;
}
